import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
  standalone: true,
})
export class DurationPipe implements PipeTransform {
  transform(value: number, withLabels = true, suffix = false): string {
    let minutes = '';
    let seconds = '';
    let suffixLabel = '';

    if (value == null || Number.isNaN(value)) return '';

    if (suffix) {
      suffixLabel = 's';
    }

    if (withLabels) {
      if (value > 60) {
        minutes = `${Math.floor(value / 60)}MIN : `;
        seconds = `${value % 60}SEK`;
      } else {
        seconds = `${value}sek`;
      }
    } else {
      const min = Math.floor(value / 60);
      const sec = value % 60;

      minutes = `${min}`;
      if (min < 10) {
        minutes = `0${min}`;
      }
      minutes = `${minutes}:`;

      seconds = `${sec}`;
      if (sec < 10) {
        seconds = `0${sec}`;
      }
    }

    return `${minutes}${seconds}${suffixLabel}`;
  }
}
